export default __webpack_public_path__ + "static/media/tosh.f4829295.png";